import { Link } from 'react-router-dom';

/**
 * CustomSemAcesso — a tela de quando a pessoa alcançou uma página que não é dela.
 *
 * Nasceu com o escopo de linha das autorizações (Fase 3b, ficha #26): a partir
 * de 10/09/2026 quem não tem `autorizacoes.fila.ver` só abre as autorizações
 * que a envolvem, e trocar o id na URL passa a devolver 403. Sem esta tela, o
 * 403 chegava como uma linha vermelha solta no meio da página — que parece
 * defeito do app, não uma porta fechada de propósito.
 *
 * **A estrutura é do tema** (`pages/extra/PageNotFound.tsx`): o mesmo
 * `card adminuiux-card`, o mesmo corpo centralizado, o mesmo botão de volta.
 * Ficaram de fora o vídeo de fundo e o número de 140px — aquilo é tela de erro
 * fatal, ocupando a janela inteira; aqui a pessoa continua dentro do app, e o
 * tamanho tem de dizer "esta página não é sua", não "o sistema quebrou".
 *
 * Genérico de propósito: qualquer tela com escopo de linha vai precisar dele.
 */
export default function CustomSemAcesso({
  titulo = 'Esta página não é sua',
  detalhe,
  voltarPara = '/',
  voltarTexto = 'Voltar',
}: {
  titulo?: string;
  /** Uma frase dizendo QUEM alcança — sem isso a tela só nega, não orienta. */
  detalhe?: string;
  voltarPara?: string;
  voltarTexto?: string;
}) {
  return (
    <div className="container-fluid mt-3">
      <div className="card adminuiux-card border-0">
        <div className="card-body py-5">
          <div className="row align-items-center justify-content-center text-center">
            <div className="col-auto">
              <i className="bi bi-shield-lock display-4 opacity-50 d-block mb-3" />
              <h4 className="fw-bold mb-1">{titulo}</h4>
              {detalhe && <p className="text-secondary mb-4">{detalhe}</p>}
              <Link to={voltarPara} className="btn btn-primary">
                {voltarTexto} <i className="bi bi-arrow-right" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
